function r(n) {
  return Math.max(0, Math.min(1, n));
}
function p(n, i) {
  const { left: c, top: a, width: f, height: l } = i.getBoundingClientRect(), o = { x: n.x - c, y: n.y - a }, e = { x: r(o.x / f), y: r(o.y / l) };
  function u(x = {}) {
    const { dir: y = "ltr", orientation: h = "horizontal", inverted: t } = x, s = typeof t == "object" ? t.x : t, g = typeof t == "object" ? t.y : t;
    return h === "horizontal" ? y === "rtl" || s ? 1 - e.x : e.x : g ? 1 - e.y : e.y;
  }
  return { offset: o, percent: e, getPercentValue: u };
}
export {
  p as getRelativePoint
};
